import { arrayOf, oneOf } from 'prop-types';
import React from 'react';
import { Play } from 'components/Icons/Play';
import {
  HAS_VIDEO_ATTR,
  IS_VIDEO_ATTR,
  IS_EXTERNAL_LINK_ATTR
} from 'constants/teasers';

// Currently we don't want to show any icon for external links
// but we still want to note when that's the case
const ATTRIBUTE_ICONS = {
  [HAS_VIDEO_ATTR]: Play,
  [IS_VIDEO_ATTR]: Play
};

function TeaserIcons({ teaserAttributes }) {
  return (
    <div className="Teaser__icons">
      {teaserAttributes
        .map(attribute => {
          const Icon = ATTRIBUTE_ICONS[attribute];
          return Icon ? (
            <div
              className={`Teaser__icon Teaser__icon--${attribute}`}
              key={attribute}
            >
              <Icon />
            </div>
          ) : null;
        })
        .filter(Boolean)}
    </div>
  );
}

TeaserIcons.propTypes = {
  teaserAttributes: arrayOf(
    oneOf([HAS_VIDEO_ATTR, IS_VIDEO_ATTR, IS_EXTERNAL_LINK_ATTR])
  ).isRequired
};

export default TeaserIcons;
